// --------------------------------------------------------------------------
// gallery.js
// --------------------------------------------------------------------------
// Uses magnific-popup for image lightbox gallery
// --------------------------------------------------------------------------

EC.gallery = function () {

    'use strict';

    let index;
    let $wrapper;

    function init () {
        $('.js-gallery').on('click', fetchImages);
    }

    function fetchImages () {
        const blockId = this.dataset.blockId;
        index = parseInt(this.dataset.index) - 1;
        $wrapper = $(this).closest('.b-gallery');
        $wrapper.addClass('b-gallery--is-loading');
        $.ajax({
            url: '/gallery-images/' + blockId,
            method: 'GET',
            success: triggerLightbox
        });
        return false;
    }

    function triggerLightbox (data) {
        $wrapper.removeClass('b-gallery--is-loading');
        $.magnificPopup.open({
            items: data.images,
            type: 'image',
            mainClass: 'b-gallery__lightbox',
            gallery: {
                enabled: true
            }
        }, index);
    }

    return {
        init: init
    };

}();